export default "__VITE_ASSET__ce9ee8fa__"